import { collection, query, where, getDocs, getFirestore } from 'firebase/firestore';

const queryBusinessAtAGlance = async () => {
  try {
    const db = getFirestore();
    const businessAtAGlanceRef = collection(db, 'businessAtAGlance');
    const querySnapshot = await getDocs(businessAtAGlanceRef);

    querySnapshot.forEach((doc) => {
    });
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error querying businessAtAGlance:', error);
    throw error;
  }
};


export const businessService = {
  checkBusinessName: async (name) => {
    try {
      const db = getFirestore();
      const businessesRef = collection(db, 'businessAtAGlance');
      const q = query(
        businessesRef,
        where('shopName', '==', name.trim())
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        return {
          available: false,
          message: 'This business name is already taken'
        };
      }

      return {
        available: true,
        message: 'This business name is available'
      };
    } catch (error) {
      return {
        available: false,
        message: 'Error checking name availability. Please try again.'
      };
    }
  }
};

export default businessService;
